module.exports = __webpack_public_path__ + "img/368.d833c1ed.svg";